import React        from 'react';
import PropTypes    from 'prop-types';
import Translations from './../../utils/Translations';

class ActionStatus extends React.Component {
	/**
	 * @return {*}
	 */
	render() {
		const suffix = this.props.active ? '--is-active' : '--is-ended',
		      label  = this.props.active ? 'Active' : 'Ended';

		return (
			<span className={"blog-post-card-event " + suffix}>
				{Translations.get('MagazineEventStatus' + label)}
			</span>
		);
	}
}

ActionStatus.propTypes = {
	active: PropTypes.bool,
};

ActionStatus.defaultProps = {
	active: false,
};

export default ActionStatus;
